import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import { Oval } from 'react-loader-spinner';
import { useDispatch, useSelector } from "react-redux";
import useUserData from '../../hooks/useUserData';
import axios from 'axios';
import Header from '../../Components/Header/Header';
import truck from '../../assets/truck_black.svg';
import calendar from '../../assets/calendar_black.svg';
import HeaderLower from '../../Components/HeaderLower/HeaderLower';
import CardDatos from './Datos/cardDatos/CardDatos';
import cart from '../../assets/carrito_Enough.svg';
import plus from '../../assets/__plus.svg';
import minus from '../../assets/__minus.svg';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { trackEvent } from "../../utils/fbpPixel";
import modoQr from "../../assets/modo-qr.png";
import { getCarrito } from '../../redux/actions';
import Carrito from '../../Components/Carrito/Carrito';
const API_URL = "https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod";
const URL = "https://43a8phnwnh.execute-api.us-east-1.amazonaws.com/prod";

export const getPrecioEnvioLocalidad = async (idLocalidad) => {
    try {
        const response = await axios.post(`${URL}/envio-localidad`, {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ idArea: 4704, codPost: idLocalidad }),
            isBase64Encoded: false,
        });
        const res = JSON.parse(response.data.body);
        return res;
    } catch (error) {
        console.log(error);
    }
};

export const postDomicilio = async (
    token, datosDomicilio,
    tipoDireccion, retiro,
    domicilioNew, documentoFacturaA,
    tipoFacturaA
) => {
    try {
        const response = await axios.post(`${URL}/agregar-domicilio`, {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ token, ...datosDomicilio, tipoDireccion, retiro, domicilioNew, tipoFacturaA, documentoFacturaA }),
            isBase64Encoded: false,
        });
        const res = JSON.parse(response.data.body);
        return res;
    } catch (error) {
        console.log(error);
    }
};

export const mercadoPagoCheckout = async (
    carrito,
    idCLiente,
    envio,
    dni,
    dolar,
    cupon,
    comentario,
    fk_idprov,
    localidad,
    telefono,
    direccion,
    entre_calles,
    nota,
    retiro_en_sucursal,
    sucursal
) => {
    try {
        const response = await axios.post('https://sistema.depcsuite.com/api/mercadopagoApi', {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({
                carrito,
                idCLiente,
                envio,
                dni,
                dolar,
                cupon,
                comentario,
                fk_idprov,
                localidad,
                telefono,
                direccion,
                entre_calles,
                nota,
                retiro_en_sucursal,
                sucursal,
                idarea: 4704
            }),
            isBase64Encoded: false,
        });
        let url = response.data.api;
        url = url && url.replace(/\\\//g, '/');
        url = url && url.split(' ')[0];
        return url;
    } catch (error) {
        console.log(error);
    }
};

export const addDomicilio = async (
    token, alias,
    fk_idtipodoc_persona,
    documento_personal,
    codpost, direccion,
    dpto, entre_calles,
    fk_idpais, fk_idprov,
    piso, descripcion,
    tipoDireccion,
    fk_idlocalidad,
    numero_celular,
    alternativa,
    razon_social,
    situacion,
    iddomicilio
) => {
    try {
        const response = await axios.post(`https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/editar-domicilio`, {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({
                token,
                alias,
                fk_idtipodoc_persona,
                documento_personal,
                codpost,
                direccion,
                dpto,
                entre_calles,
                fk_idpais,
                fk_idprov,
                piso,
                descripcion,
                tipoDireccion,
                fk_idlocalidad,
                numero_celular,
                alternativa,
                situacion,
                razon_social,
                iddomicilio
            }),
            isBase64Encoded: false,
        });
        const res = JSON.parse(response.data.body);
        return res;
    } catch (error) {
        console.log(error);
    }
};

const axiosPost = async (url, data) => {
    return await axios.post(url, {
        httpMethod: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
        isBase64Encoded: false,
    });
};

export const getProvincias = async () => {
    try {
        const response = await fetch('https://api.depcsuite.com/td/getProvincias?id=12', {
            method: "get",
            headers: {
                "Content-Type": "application/json",
            },
        });
        const res = await response.json();
        return res;
    } catch (error) {
        console.log(error);
    }
};

export const getLocalidades = async (fk_idprov) => {
    try {
        const response = await axios.post('https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/sce/conseguir-localidades', {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ fk_idprov }),
            isBase64Encoded: false,
        });
        const res = JSON.parse(response.data.body);
        return res;
    } catch (error) {
        console.log(error);
    }
};

export const getSucursales = async () => {
    try {
        const response = await axios.post(`${URL}/coseguir-sucursales`, {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ fk_idarea: 4704 }),
            isBase64Encoded: false,
        });
        const res = JSON.parse(response.data.body);
        return res;
    } catch (error) {
        console.log(error);
    }
};

export const getAllBanks = async () => {
    try {
        const response = await axios.post(
          'https://kcv9h2627l.execute-api.us-east-1.amazonaws.com/v1/conseguir-bancos',
          {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({}),
            isBase64Encoded: false,
        });
        return JSON.parse(response.data.body)
      } catch (error) {
        console.error(error);
      }
};

async function setCarritoYRedirigir(carrito, url) {
    try {
        await new Promise((resolve, reject) => {
        try {
            localStorage.setItem('carrito', JSON.stringify(carrito));
            resolve();
        } catch (error) {
            reject(error);
        }
        });
        window.open(url, '_self');
    } catch (error) {
        console.error('Error al establecer el carrito en localStorage:', error);
    }
};

const UnifiedCheckout = ({
        precioEnvio = 0,
        setPrecioEnvio,
        total = 0,
        subTotal = 0,
        carrito = [],
        precioTotalDescuento,
        precioTotal,
        precioTotalCupon,
        precioTotalCuponConOferta,
        precioTotalOferta,
        setCarrito,
        precioCuponRestante,
        diferencialConPorcentaje,
        onRemoveInvitado,
        precioDolar
    }) => {
    const {
        datosDomicilio,
        setDatosDomicilio,
        loadInitialData,
        envio,
        setEnvio
    } = useUserData();
    const token = localStorage.getItem('token');
    const location = useLocation();
    const [sucursales, setSucursales] = useState([])
    const [facturaA, setFacturaA] = useState(false)
    const [openDatosPersonales, setOpenDatosPersonales] = useState(true)
    const [loading, setLoading] = useState(false)
    const [progress, setProgress] = useState(0)
    const [errorMensaje, setErrorMensaje] = useState('')
    const [formErrors, setFormErrors] = useState({})
    const [retiro, setRetiro] = useState('Envía a domicilio')
    const [provincias, setProvincias] = useState([])
    const [provinciasFact, setProvinciasFact] = useState([])
    const [localidades, setLocalidades] = useState([])
    const [localidadesFact, setLocalidadesFact] = useState([])
    const [cupon, setCupon] = useState();
    const [medioPago, setMedioPago] = useState('20');
    const [errorCupon, setErrorCupon] = useState(false);
    const [cuponTrue, setCuponTrue] = useState(false);
    const [cuponProductos, setCuponProductos] = useState([]);
    const [errorComprobante, setErrorComprobante] = useState(false);
    const [emailNoExiste, setEmailNoExiste] = useState(false);
    const [localidadesFacturacion, setLocalidadesFacturacion] = useState([])
    const [carritoOpen, setCarritoOpen] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const searchParams = new URLSearchParams(location.search);
    const [isOpen, setIsOpen] = useState(false);
    const pass = searchParams.get('pass');
    const [loadingBuy, setLoadingBuy] = useState(false);
    const [buttonText, setButtonText] = useState("Pagar con MercadoPago");
    const [banks, setBanks] = useState();
    const [comprobante, setComprobante] = useState({
        txtArchivoDocumento: '',
        importe: 0,
        banco: 0,
        fecha: ''
    });

    useEffect(() => {
        const fetchProvincias = async () => {
            const data = await getAllBanks();
            setBanks(data);
            setComprobante(p => ({ ...p, banco: data[0]?.idbanco || 0 }));
            const provs = await getProvincias()
            setDatosDomicilio(p => ({ ...p, fk_idprov: provs[0].idprov }))
            setProvincias(provs)
        }
        fetchProvincias()
    }, [])

    useEffect(() => {
        ;(async () => {
        await loadInitialData()
        const api = await getSucursales()
        setSucursales(api.results)
        localStorage.setItem('sucursal', api.results?.[0]?.idsucursal || '42')
        const prov = await getProvincias()
            setDatosDomicilio(p => ({ ...p, fk_idprov: prov[0].idprov, fk_idprov_facturacion: prov[0].idprov }))
            setProvincias(prov)
            setProvinciasFact(prov)
            const locs = await getLocalidades(prov[0].idprov.toString())
            setLocalidades(locs)
            setLocalidadesFacturacion(locs)
        })()
    }, [])

    const handleSeleccionarOpcion = (opcion) => {
        setMedioPago(opcion);
    };

    const subirComprobante = async () => {
        setLoadingBuy(true);
        setLoading(true)
        setProgress(0)
        const formData = new FormData();
        const fechaAEnviar = comprobante.fecha || new Date().toISOString().split('T')[0];
        if (!comprobante.txtArchivoDocumento) {
            setErrorMensaje('El archivo es requerido');
            setLoading(false);
            setLoadingBuy(false);
            return false;
        }
        const fileN = comprobante.txtArchivoDocumento;
        const ext = fileN.name.split('.').pop().toLowerCase();
        if (!['jpg','jpeg','png','pdf'].includes(ext)) {
            setErrorMensaje('Formato inválido. Solo jpg, jpeg, png o pdf');
            setLoading(false);
            setLoadingBuy(false);
            return false;
        }
        
        if(!comprobante.importe || isNaN(comprobante.importe) || Number(comprobante.importe) <= 0) {
            setErrorMensaje('El importe es requerido y debe ser un número válido');
            setLoading(false);
            setLoadingBuy(false);
            return false;
        }
        if(!comprobante.banco || isNaN(comprobante.banco) || Number(comprobante.banco) <= 0) {
            setErrorMensaje('El banco es requerido y debe ser un número válido');
            setLoading(false);
            setLoadingBuy(false);
            return false;
        }
        if(!fechaAEnviar) {
            setErrorMensaje('La fecha es requerida');
            setLoading(false);
            setLoadingBuy(false);
            return false;
        }
        const file = comprobante.txtArchivoDocumento;
        formData.append('txtArchivoDocumento', file, file.name);

      
        formData.append('importe', comprobante.importe);
        formData.append('banco', comprobante.banco);
        formData.append('fecha', fechaAEnviar);
        formData.append('idarea', 4704);
      
        const response = await axios.post(
          'https://sistema.depcsuite.com/api/subir-comprobante',
          formData
        );

        if(response.data.message == 'The txt archivo documento must be a file of type: jpg, jpeg, png, pdf. (and 1 more error)'){
            setErrorComprobante(true);
            setLoading(false)
            setLoadingBuy(false)
        }
        return response.data.message;
    };

    const deleteCarrito = async () => {
        await axios.post('https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/delete-carrito', {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ token: token }),
            isBase64Encoded: false,
        });
        localStorage.removeItem('carrito');
    }

    const onClickCupon = async () => {
          const response = await axios.post('https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/sce/agregar-cupon', {
            httpMethod: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            queryStringParameters: {},
            pathParameters: {},
            body: JSON.stringify({ token: localStorage.getItem('token'), cuponNombre: (cupon || '') }),
            isBase64Encoded: false,
          });
          const data = JSON.parse(response.data.body);
          if (data.message) {
            setCuponTrue(true);
            setCuponProductos(data.productos);
          } else {
            setErrorCupon(true);
          }
    };

    const handleChange = ({ target: { name, value } }) => {
        let val = value;
        if (name === 'documento_personal') {
            val = value.replace(/\D/g, '');
            const tipo = datosDomicilio.fk_idtipodoc_persona;
            const max = tipo === 1 ? 11 : 8;
            val = val.slice(0, max);
        }
        if (name === 'cuit') {
            val = value.replace(/\D/g, '').slice(0, 11);
        }
        setDatosDomicilio(p => ({ ...p, [name]: val }));
        setFormErrors(f => ({ ...f, [name]: undefined }));
    };

    const handleChangeSelectProv = async (opt) => {
        const prov = Number(opt.value);

        const locs = await getLocalidades(prov.toString());
        setLocalidades(locs);

        setDatosDomicilio(prev => ({
          ...prev,
          fk_idprov: prov,
          fk_idlocalidad: null,
        }));
      
        setFormErrors(prev => ({
          ...prev,
          fk_idlocalidad: undefined
        }));
      };
      
    const handleChangeSelectProvFact = async opt => {
        const prov = Number(opt.value)
        const locs = await getLocalidades(prov.toString())
        setProvinciasFact(prev => prev)
        setLocalidadesFact(locs)
        setDatosDomicilio(p => ({
          ...p,
          fk_idprov_facturacion: prov
        }))
    }
    
    const handleChangeSelectLocalidad = async opt => {
        const loc = Number(opt.value)
        setDatosDomicilio(p => ({ ...p, fk_idlocalidad: loc }));
        setFormErrors(f => ({ ...f, fk_idlocalidad: undefined }));
    }

    const handleChangeSelectLocalidadFact = async opt => {
        const loc = Number(opt.value)
        setDatosDomicilio(p => ({ ...p, fk_idlocalidad_facturacion: loc }))
    }

    useEffect(() => {
        const calcularEnvio = async () => {
          if (retiro !== 'Envía a domicilio') {
            setEnvio(0)
            return
          }
          const response = await axiosPost(
            'https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/sce/envio',
            { codPost: datosDomicilio.fk_idlocalidad }
          )
          const envioData = JSON.parse(response.data.body)
          setEnvio(envioData.length > 0 ? envioData[0].importe : 0)
        }
      
        calcularEnvio()
    }, [datosDomicilio.fk_idlocalidad, retiro])

    const scrollToTop = () => {
        window.scrollTo({
        top: 0,
        behavior: 'smooth'
        });
    };

    const validateForm = () => {
        const errs = {}
        const base = [
        'nombre','apellido','calle', 'nro','codpost',
        'numero_celular','documento_personal',
        'fk_idprov','fk_idlocalidad',
        ]
        const req = retiro !== 'Retiro al local' ? [...base, 'piso','dpto', 'entre_calles', 'nota'] : base
        req.forEach(f => {
            if (!datosDomicilio[f]) errs[f] = 'Requerido'
        })
        if (
        !localStorage.getItem('token') &&
        (!datosDomicilio.email || !/\S+@\S+\.\S+/.test(datosDomicilio.email))
        ) errs.email = 'Email válido es requerido'
        if (facturaA) {
        ['situacion','cuit'].forEach(f => {
            if (!datosDomicilio[f]) errs[f] = 'Requerido'
        })
        if (datosDomicilio.tipoDireccion) {
            [
            'calle_facturacion', 'nro_facturacion','codpost_facturacion',
            'fk_idprov_facturacion','fk_idlocalidad_facturacion',
            'dpto_facturacion','piso_facturacion',
            ].forEach(f => {
            if (!datosDomicilio[f]) errs[f] = 'Requerido'
            })
        }
        }
        setFormErrors(errs)
        console.log('Errores de formulario:', errs)
        return !Object.keys(errs).length
    }

    const handleChangeInput = (e) => {
        const { name, value, type, files } = e.target;
        setComprobante({
        ...comprobante,
        [name]: type === 'file' ? files[0] : value
        });
        setFormErrors({ ...formErrors, [name]: null });
    };

    const options = banks && banks.length > 0 && banks.map(item => ({
        value: item.idbanco,
        label: item.nombre
    }));
    
    const createDataDomicilio = (tipoDireccion, values) => {
        const isFacturacion = tipoDireccion == 'Facturacion';
    
        const getValue = (keyCamel, keySnake) => values[keyCamel] ?? values[keySnake];
        console.log('values', values)
        const direccion = getValue("calle") + ' ' + getValue("nro");
        console.log('direccion', direccion)
        return {
            token: localStorage.getItem("token"),
            alias: getValue("alias"),
            alternativa: getValue("alternativa"),
            fk_idtipodoc_persona: isFacturacion && getValue('tipoDireccion') ? "1" : "7",
            documento_personal: isFacturacion && getValue('tipoDireccion') ? getValue("cuit") : getValue("documento_personal"),
            codpost: isFacturacion && getValue('tipoDireccion') ? getValue("codpostFacturacion", "codpost_facturacion") : getValue("codpost"),
            direccion: isFacturacion && getValue('tipoDireccion') ? getValue("calleFacturacion", "calle_facturacion") ? getValue("calleFacturacion", "calle_facturacion") + ' ' + getValue("nroFacturacion", "nro_facturacion") : direccion : direccion,
            dpto: getValue("dpto"),
            entre_calles: getValue("entre_calles"),
            situacion: getValue("situacion"),
            razon_social: getValue("razon_social") || getValue("nombre"),
            fk_idprov: isFacturacion && getValue('tipoDireccion') ? getValue("fk_idprovFacturacion", "fk_idprov_facturacion") : getValue("fk_idprov"),
            provincia: isFacturacion && getValue('tipoDireccion')
                ? getValue("provinciaFacturacion", "provincia_facturacion")
                : getValue("provincia"),
            piso: getValue("piso"),
            nota: getValue("nota"),
            tipoDireccion,
            telefono: `${getValue("numero_celular")}`,
            numero_celular: `${getValue("numero_celular")}`,
            fk_idlocalidad: isFacturacion && getValue('tipoDireccion')
                ? getValue("fk_idlocalidadFacturacion", "fk_idlocalidad_facturacion")
                : getValue("fk_idlocalidad"),
            localidad: isFacturacion && getValue('tipoDireccion')
                ? getValue("localidadFacturacion", "localidad_facturacion")
                : getValue("localidad"),
            fk_idpais: isFacturacion && getValue('tipoDireccion') ? getValue("fk_idpaisFacturacion", "fk_idpais_facturacion") : getValue("fk_idpais"),
            domicilioNew: getValue("iddomicilio") ?? "new",
            ocupacion: getValue("ocupacion"),
            empresa: getValue("empresa"),
            nombre: getValue("nombre"),
            apellido: getValue("apellido"),
        };
    };
    
    
    const handleMercadoPago = async () => {
        setLoadingBuy(true);
        setLoading(true)
        if (!validateForm()) {
            console.error('Formulario inválido', formErrors);
            setErrorMensaje('Completa los campos')
            window.scrollTo({ top: 550, behavior: 'smooth' })
            setLoadingBuy(false);
            setLoading(false)
            return
        }
        let medioPagoNombre = '';
        switch (medioPago) {
            case '1':
                medioPagoNombre = 'Transferencia';
                break;
            case '20':
                medioPagoNombre = 'Mercadopago';
                break;
            case '25':
                medioPagoNombre = 'MODO';
                break;
            default:
                medioPagoNombre = 'Mercadopago';
                break;
        }
        setProgress(0)
        console.log('entré 2')
        const precioFinal = Number(((medioPago == '1') && medioPago ? cuponTrue ? precioTotalDescuento - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotalDescuento + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : cuponTrue ? precioTotal - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotal + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio)));
        const iv = setInterval(
            () => setProgress(p => (p >= 90 ? (clearInterval(iv), p) : p + 10)),
            300
        )
        try {
            console.log('entré try')
            const mapaLocalidades = {};
            localidades?.forEach((localidad) => {
                mapaLocalidades[localidad.idlocalidad] = localidad.nombre;
            });

            const mapaProvincias = {};
            provincias?.forEach((provincia) => {
                mapaProvincias[provincia.idprov] = provincia.descprov;
            });

            const info = {
                correo: datosDomicilio.email,
                name: datosDomicilio.nombre,
                lastname: datosDomicilio.apellido,
                dni: datosDomicilio.documento_personal,
                entre_calles: datosDomicilio.entre_calles,
                telefono: `${datosDomicilio.numero_celular}`,
                numero_celular: `${datosDomicilio.numero_celular}`,
                fk_idprov: datosDomicilio.fk_idprov,
                totalDescuentoPromo: 0,
                fk_idprovFacturacion: datosDomicilio.fk_idprov_facturacion,
                fk_idlocalidad: datosDomicilio.fk_idlocalidad,
                fk_idlocalidadFacturacion: datosDomicilio.fk_idlocalidad_facturacion,
                direccion: datosDomicilio.calle + ' ' + datosDomicilio.nro,
                calle: datosDomicilio.calle,
                nro: datosDomicilio.nro,
                calle_facturacion: datosDomicilio.calle_facturacion,
                nro_facturacion: datosDomicilio.nro_facturacion,
                direccionFacturacion: datosDomicilio.calle_facturacion + ' ' + datosDomicilio.nro_facturacion,
                piso: datosDomicilio.piso,
                dpto: datosDomicilio.dpto,
                codpost: datosDomicilio.codpost,
                codpostFacturacion: datosDomicilio.codpost_facturacion,
                cuit: datosDomicilio.cuit,
                razon_social: datosDomicilio.razon_social,
                situacion: datosDomicilio.situacion,
                idarea: 4704
            }

            if (token) {
                const token = localStorage.getItem('token');
                if (!facturaA) {
                    await axios.post('https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/editar-domicilio', {
                        httpMethod: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        queryStringParameters: {},
                        pathParameters: {},
                        body: JSON.stringify({ ...datosDomicilio, token, tipoDireccion: 'Casa', domicilioNew: datosDomicilio.iddomicilio ? datosDomicilio.iddomicilio : 'new' }),
                        isBase64Encoded: false,
                    });
                    await reedirectCheckout(medioPagoNombre, {
                        casa: createDataDomicilio("Casa", datosDomicilio),
                        facturacion: null,
                        info: info
                    })
                } else {
                    await axios.post('https://43a8phnwnh.execute-api.us-east-1.amazonaws.com/prod/agregar-domicilio/facturacion', {
                        httpMethod: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        queryStringParameters: {},
                        pathParameters: {},
                        body: JSON.stringify({ ...datosDomicilio, token, tipoDireccion: 'Casa', iddomicilio: datosDomicilio.iddomicilio ? datosDomicilio.iddomicilio : 'new' }),
                        isBase64Encoded: false,
                    });
                    await axios.post('https://43a8phnwnh.execute-api.us-east-1.amazonaws.com/prod/agregar-domicilio/facturacion', {
                        httpMethod: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        queryStringParameters: {},
                        pathParameters: {},
                        body: JSON.stringify({
                            nro_facturacion: datosDomicilio.tipoDireccion ? datosDomicilio.nro_facturacion : datosDomicilio.nro,
                            calle_facturacion: datosDomicilio.tipoDireccion ? datosDomicilio.calle_facturacion : datosDomicilio.calle,
                            piso: datosDomicilio.tipoDireccion ? datosDomicilio.piso_facturacion : datosDomicilio.piso,
                            fk_idprov: datosDomicilio.tipoDireccion ? datosDomicilio.fk_idprov_facturacion : datosDomicilio.fk_idprov,
                            codpost: datosDomicilio.tipoDireccion ? datosDomicilio.codpost_facturacion : datosDomicilio.codpost,
                            fk_idpais: 12,
                            dpto: datosDomicilio.tipoDireccion ? datosDomicilio.dpto_facturacion : datosDomicilio.dpto,
                            piso: datosDomicilio.tipoDireccion ? datosDomicilio.piso_facturacion : datosDomicilio.piso,
                            numero_celular: datosDomicilio.numero_celular_facturacion,
                            calle: datosDomicilio.tipoDireccion ? datosDomicilio.calle_facturacion : datosDomicilio.calle,
                            nro: datosDomicilio.tipoDireccion ? datosDomicilio.nro_facturacion : datosDomicilio.nro,
                            alias: '',
                            entre_calles: datosDomicilio.tipoDireccion ? datosDomicilio.entre_calles_facturacion : datosDomicilio.entre_calles,
                            alternativa: '',
                            descripcion: '',
                            email: '',
                            retiro: 1,
                            fk_idtipodoc_persona: 1,
                            documento_personal: datosDomicilio.tipoDireccion ? datosDomicilio.cuit : datosDomicilio.documento_personal,
                            nombre: datosDomicilio.nombre,
                            apellido: datosDomicilio.apellido,
                            fk_idlocalidad: datosDomicilio.tipoDireccion ? datosDomicilio.fk_idlocalidad_facturacion : datosDomicilio.fk_idlocalidad,
                            razon_social: datosDomicilio.tipoDireccion ? datosDomicilio.razon_social : datosDomicilio.nombre + ' ' + datosDomicilio.apellido,
                            situacion: datosDomicilio.tipoDireccion ? datosDomicilio.situacion : '1',
                            token,
                            tipoDireccion: 'Facturación',
                            domicilioNew: datosDomicilio.iddomicilio ? datosDomicilio.iddomicilio : 'new'
                        }),
                        isBase64Encoded: false,
                    });
                    await reedirectCheckout(medioPagoNombre, {
                        casa: createDataDomicilio("Casa", datosDomicilio),
                        facturacion: createDataDomicilio("Facturacion", datosDomicilio),
                        info: info
                    })
                }
            } else {
                if(facturaA){
                    const dataDomicilioFacturacion = createDataDomicilio("Facturacion", datosDomicilio);
                    const dataDomicilioCasa = createDataDomicilio("Casa", datosDomicilio);
                    const datos = {
                        casa: dataDomicilioCasa,
                        facturacion: dataDomicilioFacturacion,
                        info: info
                    };
                    await reedirectCheckout(medioPagoNombre, datos)
                }else{
                    const dataDomicilioCasa = createDataDomicilio("Casa", datosDomicilio);
                    const datos = {
                        casa: dataDomicilioCasa,
                        facturacion: null,
                        info: info
                    };
                    await reedirectCheckout(medioPagoNombre, datos)
                }
            }
            setProgress(100)
        } catch(error) {
            setErrorMensaje('Error en pago')
        } finally {
            clearInterval(iv)
            setLoading(false)
        }
    };

    const reedirectCheckout = async (medioPago, datos) => {
        console.log('entré 3')
        const precioFinal = Number(((medioPago == '1') && medioPago ? cuponTrue ? precioTotalDescuento - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotalDescuento + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : cuponTrue ? precioTotal - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotal + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio)));
        const idCLiente = localStorage.getItem('userId') || ''; 
        const envioFinal = Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ?
            0 : envio !== 0 ? envio : 0
        try {
            let idpago = '';
            const token = localStorage.getItem('token');
            const { casa, facturacion, info } = datos;

            if(medioPago === 'Transferencia'){
                const validationErrors = validateForm();
                if (Object.keys(validationErrors).length > 0) {
                    setFormErrors(validationErrors);
                    setIsProcessing(false);
                    return;
                }
                idpago = await subirComprobante();
                if(!idpago){
                    return;
                }
            }
            if (facturacion) {
                const data = {
                    ...casa,
                    facturacion,
                    idarea: 4704,
                    idCLiente: idCLiente || '',
                    dni: casa.dni,
                    comentario: casa ? casa.nota : '',
                    fk_idprov: casa ? casa.fk_idprov : '',
                    localidad: casa ? casa.fk_idlocalidad : '',
                    telefono: casa ? casa.numero_celular : '',
                    direccion: casa ? casa.direccion : '',
                    calle: casa ? casa.calle : '',
                    nro: casa ? casa.nro : '',
                    piso: casa ? casa.piso : '',
                    dpto: casa ? casa.dpto : '',
                    entre_calles: casa ? casa.entre_calles : '',
                    medioPago: medioPago,
                    retiro_en_sucursal: retiro === 'Retiro al local' ? 1 : 0,
                    sucursal: retiro === 'Retiro al local' ? 43 : 42,
                    nota: casa ? casa.nota : '',
                    envio: envioFinal,
                    idPago: idpago,
                    pago:  0,
                    totalDescuentoPromo: 0,
                    precioMatriz: 0,
                    infoVendedor: false,
                    info : {casa, facturacion: {...facturacion, info}, info},
                    carrito: carrito,
                };
                localStorage.removeItem('idpago');
                
                const formData = new FormData();
                formData.append('data', JSON.stringify(data));
        
                const response = await axios.post(
                    "https://sistema.depcsuite.com/api/mercadopagopayment",
                    formData,
                    {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    }
                );
                localStorage.removeItem('carrito-sce-product-manager');
                window.location.href = response.data.api;
            } else {
            const data = {
                idarea: 4704,
                idCLiente: idCLiente || '',
                dni: casa.dni,
                comentario: casa ? casa.nota : '',
                fk_idprov: casa ? casa.fk_idprov : '',
                localidad: casa ? casa.fk_idlocalidad : '',
                telefono: casa ? casa.numero_celular : '',
                direccion: casa ? casa.direccion : '',
                calle: casa ? casa.calle : '',
                nro: casa ? casa.nro : '',
                entre_calles: casa ? casa.entre_calles : '',
                medioPago: medioPago,
                retiro_en_sucursal: retiro === 'Retiro al local' ? 1 : 0,
                sucursal: retiro === 'Retiro al local' ? 43 : 42,
                idPago: idpago,
                nota: casa ? casa.nota : '',
                envio: envioFinal,
                totalDescuentoPromo: 0,
                pago:  0,
                precioMatriz: 0,
                infoVendedor: false,
                info: {casa: {...casa, info}, info},
                carrito: carrito,
            };
            
            const formData = new FormData();
            formData.append('data', JSON.stringify(data));
    
            const response = await axios.post(
                "https://sistema.depcsuite.com/api/mercadopagopayment",
                formData,
                {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
                }
            );
            localStorage.removeItem('idpago');
            localStorage.removeItem('carrito-sce-product-manager');
            window.location.href = response.data.api;
            }
        } catch (error) {
          setButtonText("Hubo un error");
          setProgress(0);
          setIsProcessing(false);
          console.error("Error en el proceso de pago:", error);
        } finally {
            
            setProgress(0);
            setIsProcessing(false);
            setLoading(false)
        }
    };

    const selectedBank = options?.find(option => option.value === comprobante.banco) || null;

    useEffect(() => {
        const init = async () => {
            const provs = await getProvincias()
            setProvincias(provs)
            const firstProv = provs[0].idprov
            const locs = await getLocalidades(firstProv.toString())
            setLocalidades(locs)
            setDatosDomicilio(p => ({
                ...p,
                fk_idprov: firstProv
            }))
            const provsFact = await getProvincias()
            setProvinciasFact(provsFact)
            setDatosDomicilio(p => ({ ...p, fk_idprov_facturacion: provsFact[0].idprov }))
            const locsFact = await getLocalidades(provsFact[0].idprov.toString())
            setLocalidadesFact(locsFact)
        }
        init()
    }, [])

    const getProvinciaOption = id => {
        const p = provincias.find(x => x.idprov === id)
        return p && { value: p.idprov, label: p.descprov === 'Capital Federal' ? 'CABA' : p.descprov }
    }
    const getProvinciaOptionFact = id => {
        const p = provinciasFact.find(x => x.idprov === id)
        return p && { value: p.idprov, label: p.descprov === 'Capital Federal' ? 'CABA' : p.descprov }
    }

    const tipoDocumentoOptions = [
        { value: 7, label: 'DNI' },
        { value: 1, label: 'CUIT' },
    ]

    const getLocalidadOption = id => {
        if (!id) return null;
        const l = localidades.find(x => x.idlocalidad === id);
        return l ? { value: l.idlocalidad, label: l.nombre } : null;
    };

    const getLocalidadOptionFact = id => {
        const l = localidadesFact.find(x => x.idlocalidad === id)
        return l && { value: l.idlocalidad, label: l.nombre }
    }
    
    const handleSelectChange = async (opt, name) => {
        setDatosDomicilio(p => ({ ...p, [name]: opt.value }))
        if (name === 'fk_idprov_facturacion') {
        const locs = await getLocalidades(opt.value)
        setLocalidadesFacturacion(locs)
        setDatosDomicilio(p => ({ ...p, fk_idlocalidad_facturacion: locs[0]?.idlocalidad }))
        }
    }
    
    const getTipoDocumentoOption = id =>
        tipoDocumentoOptions && tipoDocumentoOptions.find(x => x.value === id) || null

    const handleChangeSelect = (selectedOption) => {
        setComprobante({
        ...comprobante,
        banco: selectedOption ? selectedOption.value : 0
        });
        setFormErrors({
        ...formErrors,
        banco: null
        });
    };

    useEffect(() => {
        setComprobante(p => ({ ...p, importe: Number(((medioPago == '1') && medioPago ? cuponTrue ? precioTotalDescuento - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotalDescuento + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : cuponTrue ? precioTotal - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotal + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio))) }))
    }, [envio, medioPago, precioTotal, precioTotalDescuento, precioCuponRestante, cuponTrue, datosDomicilio.fk_idprov]);

  return (
    <div className="pb-[65px]">
        <Header/>
        <HeaderLower/>
        <div className='bg-[#EFEFED] w-full pt-32'>
            <p className='text-sm text-left lg:ml-16 ml-8 font-semibold'><a className='font-normal' href="/">Home {'>'}</a> Login</p>
            <p className='text-5xl my-10 pb-24'>
            Tu Carrito
            </p>
        </div>
        <div className="lg:hidden fixed inset-x-0 bottom-0 z-50 bg-[#f9f9fb] max-h-[80vh] overflow-y-auto">
            <div onClick={() => setIsOpen(!isOpen)} className="flex ml-1 pt-3 pb-3 px-4 justify-between">
                <div className='flex flex-row'>
                    <img src={cart} className='w-4' alt="cart" />
                    <p className='text-left text-sm mt-1 font-semibold ml-1 text-[#E40F1B]'>
                        Mi carrito: {Number(((medioPago == '1') && medioPago ? cuponTrue ? precioTotalDescuento - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotalDescuento + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : cuponTrue ? precioTotal - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotal + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio))).toLocaleString('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 })}
                    </p>
                </div>
                <div>
                    {isOpen ? (
                        <button onClick={() => setIsOpen(false)}>
                            <img src={minus} alt='cerrar' />
                        </button>
                    ) : (
                        <button onClick={() => setIsOpen(true)}>
                            <img src={plus} alt='abrir' />
                        </button>
                    )}
                </div>
            </div>
            {isOpen && (
                <div className='bg-[#f9f9fb] h-auto ml-1 px-4 pb-4 pt-2'>
                    <div className='space-y-2'>
                        <div>
                            {carrito && loading ? (
                                carrito.map((item, index) => (
                                    <div key={index}>
                                        {Number(item.precio_dolar) !== 0 && (
                                            <div>
                                                <CardDatos setCarrito={setCarrito} onRemoveInvitado={onRemoveInvitado} precio={medioPago} dolar={precioDolar} item={item} setLoading={setLoading} />
                                                <div className='border-b-2 my-2 border-opacity-30'></div>
                                            </div>
                                        )}
                                    </div>
                                ))
                            ) : (
                                <div className="flex justify-center items-center mt-32 mb-60">
                                    <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#E40F1B]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                    </svg>
                                    <span className="sr-only">Loading...</span>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className='text-xs text-left'>
                        <div className='flex justify-between font-semibold my-2'>
                            <p>Subtotal:</p>
                            <p>{Number(precioTotal).toLocaleString('es-AR', {
                                style: 'currency',
                                currency: 'ARS',
                                maximumFractionDigits: 0,
                                })}</p>
                        </div>
                        {(medioPago === '1') && <div className='border-b-2 my-2'></div>}
                        {(medioPago === '1') && <div className='flex justify-between font-semibold my-2'>
                            <p>Descuento por pago con transferencia:</p>
                            <p>{Number(diferencialConPorcentaje).toLocaleString('es-AR', {
                                style: 'currency',
                                currency: 'ARS',
                                maximumFractionDigits: 0,
                            })}</p>
                        </div>}
                        <div className='border-b-2 my-2'></div>
                        <div className='flex justify-between font-semibold my-2'>
                            <p>Envío:</p>
                            <p>{Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ?
                                <p>GRATIS</p>
                                :
                                envio !== 0 ?
                                <p>+{Number(envio).toLocaleString('es-AR', {
                                    style: 'currency',
                                    currency: 'ARS',
                                    maximumFractionDigits: 0,
                                    })}</p>:
                                <p>A cargo del cliente</p>   
                            }</p>
                        </div>
                        <div className='border-b-2 my-2'></div>
                        <div className='flex justify-between font-semibold my-2'>
                            <p>TOTAL</p>
                            <p>{Number(((medioPago == '1') && medioPago ? cuponTrue ? precioTotalDescuento - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotalDescuento + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : cuponTrue ? precioTotal - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotal + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio))).toLocaleString('es-AR', {
                                style: 'currency',
                                currency: 'ARS',
                                maximumFractionDigits: 0,
                            })}</p>
                        </div>
                        <div className='border-b-2 my-2'></div>
                        <div className='flex justify-between'>
                            <p onClick={() => {
                                setIsOpen(false);
                                setCarritoOpen(true);
                            }} className='text-left text-[#E40F1B] w-1/2 mt-3 underline text-sm opacity-70'>Modificar carrito</p>
                            <p className='text-right text-sm w-1/2 opacity-70'>Precio en pesos argentinos. Incluye impuestos.</p>
                        </div>
                    </div>
                </div>
            )}
        </div>
        <Carrito isOpen={carritoOpen} setIsOpen={setCarritoOpen} />
        <div className="flex flex-col lg:px-[80px] px-[20px] text-left sm:flex-row">
        <div className="w-full max-w-[881px] 2xl:max-w-[942px] mb-[40px]">
          {!localStorage.getItem('token') && (
            <div className="flex-col text-[#242222] leading-[24px] text-lg text-start flex justify-start">
              <a href="/ingresar?f=t" className="text-xl underline uppercase">Iniciar sesión</a>
            </div>
          )}
          <div className="pt-5">      
            <div className="">
                {!pass ? (
                    <div>
                    <p className="text-left text-lg mt-5 font-semibold">Forma de pago</p>
                    <p className="text-left mt-2">Todas las transacciones son seguras y están encriptadas.</p>
                    </div>
                ) : (
                    <div>
                    <p className="text-center text-lg mt-16 font-semibold">Tu compra ha sido exitosa</p>
                    </div>
                )}
                {!pass && (
                    <div className='grid grid-cols-2 mt-5'>
                    <button
                        className={`border mr-2 rounded-sm text-sm h-16 items-center flex flex-row ${medioPago === '20' ? 'bg-gray-200' : ''}`}
                        onClick={() => handleSeleccionarOpcion('20')}
                    >
                        <input
                        type="radio"
                        name="opcion"
                        className='ml-2'
                        id="20"
                        checked={medioPago === '20'}
                        onChange={() => handleSeleccionarOpcion('20')}
                        />
                        <p className='ml-2'>Pago con Mercado Pago</p>
                    </button>
                    <button
                        className={`border ml-2 rounded-sm text-sm h-16 items-center flex flex-row ${medioPago === '1' ? 'bg-gray-200' : ''}`}
                        onClick={() => handleSeleccionarOpcion('1')}
                    >
                        <input
                        type="radio"
                        name="opcion"
                        className='ml-2'
                        id="1"
                        checked={medioPago === '1'}
                        onChange={() => handleSeleccionarOpcion('1')}
                        />
                        <p className='ml-2'>Transferencia (20% OFF)</p>
                    </button>
                    </div>
                )}
                {!pass && (
                    <button
                    className={`border mr-2 mt-5 w-2/4 lg:ml-32 ml-20 rounded-sm text-sm h-16 items-center flex flex-row ${medioPago === '25' ? 'bg-gray-200' : ''}`}
                    onClick={() => handleSeleccionarOpcion('25')}
                    >
                    <input
                        type="radio"
                        name="opcion"
                        className='ml-2'
                        id="25"
                        checked={medioPago === '25'}
                        onChange={() => handleSeleccionarOpcion('25')}
                    />
                    <p className='ml-2'>Pago con MODO</p>
                    </button>
                )}
            </div>
            <div className='mt-10 text-left'>
                <p className='font-semibold text-lg mb-5'>Forma de entrega</p>
                <div className='grid grid-cols-2'>
                    <button onClick={() => setRetiro('Envía a domicilio')} className={`${retiro === 'Envía a domicilio' ? 'bg-gray-200' : ''} border border-black border-opacity-60 mr-2 rounded-sm text-sm h-16 items-center flex flex-row`}>
                        <input type="radio" id='Envía a domicilio' checked={retiro === 'Envía a domicilio'} onChange={() => setRetiro('Envía a domicilio')} className='ml-2' />
                        <img src={truck} className='w-5 ml-2' alt="Envía a domicilio" />
                        <p className='lg:ml-2 ml-0.5'>Envío a domicilio</p>
                    </button>
                    <button onClick={() => setRetiro('Retiro al local')} className={`${retiro === 'Retiro al local' ? 'bg-gray-200' : ''} border border-black border-opacity-60 rounded-sm text-sm h-16 items-center flex flex-row`}>
                        <input type="radio" className='ml-2' id='Retiro al local' checked={retiro === 'Retiro al local'} onChange={() => setRetiro('Retiro al local')} />
                        <img src={calendar} className='w-5 ml-2' alt="Retiro al local" />
                        <p className='ml-2'>Retiro en el local</p>
                    </button>
                </div>
            </div>
            {retiro === 'Retiro al local' && (
                <div className='text-left flex flex-col'>
                    <p className='text-lg my-3 font-semibold'>Lugar de Retiro</p>
                    <div className='border border-[#E40F1B] bg-[#ffb3b3] font-bold text-left'>
                        <div className='m-3'>
                            <p className='font-semibold'>Depósito - GRATIS</p>
                            <span className='text-left'>
                                Lunes a Viernes (hábiles) de 9:30 a 13:30 hs. - Requiere coordinación previa - WA <a className='border-b-[0.5px]' href="https://api.whatsapp.com/send?phone=541132619277">11-3261-9277</a> CABA, Barracas, California 1628 - Portón gris, sin timbre.
                            </span>
                        </div>
                    </div>
                </div>
            )}
            <p className='font-semibold text-lg mt-10'>Domicilio de {retiro === 'Retiro al local' ? '' : ' entrega y '}facturación</p>
            {openDatosPersonales && (
              <div className="grid gap-5 mt-5 grid-cols-1 md:grid-cols-2">
                {!localStorage.getItem('token') && (
                  <div className="md:col-span-2">
                    <label>Email *</label>
                    <input type="text" name="email" value={datosDomicilio.email || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.email?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Email *" />
                    {emailNoExiste && (
                      <p className="text-red-500 text-sm mt-1">El email ingresado no existe.</p>)}
                  </div>
                )}
                {emailNoExiste && localStorage.getItem('token') && (
                    <p className="text-red-500 text-sm mt-1">El email ingresado no existe. Email: {datosDomicilio.email}</p>)}
                <div>
                  <label>Nombre *</label>
                  <input type="text" name="nombre" value={datosDomicilio.nombre || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.nombre?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Nombre *" />
                </div>
                <div>
                  <label>Apellido *</label>
                  <input type="text" name="apellido" value={datosDomicilio.apellido || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.apellido?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Apellido *" />
                </div>
                <div>
                  <label>Calle *</label>
                  <input type="text" name="calle" value={datosDomicilio.calle || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.calle?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Calle *" />
                </div>
                <div>
                  <label>Número *</label>
                  <input type="text" name="nro" value={datosDomicilio.nro || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.nro?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Número *" />
                </div>
                <div>
                  <label>Piso{retiro !== 'Retiro al local'?' *':''}</label>
                  <input type="text" name="piso" value={datosDomicilio.piso || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.piso?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Piso *" />
                </div>
                <div>
                  <label>Dpto{retiro !== 'Retiro al local'?' *':''}</label>
                  <input type="text" name="dpto" value={datosDomicilio.dpto || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.dpto?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Dpto *" />
                </div>
                
                <div>
                  <label>Provincia *</label>
                  <Select name="fk_idprov" value={getProvinciaOption(datosDomicilio.fk_idprov)} onChange={handleChangeSelectProv} options={provincias.map(p => p.descprov==='Capital Federal'?{value:p.idprov,label:'CABA'}:{value:p.idprov,label:p.descprov})} styles={{
                    control:(pr)=>({ ...pr,height:45,fontSize:'14px',borderRadius:0,backgroundColor:'#FFFFFF80',borderColor:formErrors.fk_idprov?'#ef4444':pr.borderColor})
                  }} placeholder="Provincia" />
                </div>
                <div>
                    <label>Localidad *</label>
                    <Select name="fk_idlocalidad" value={getLocalidadOption(datosDomicilio.fk_idlocalidad)} onChange={handleChangeSelectLocalidad} options={localidades.map(l=>({value:l.idlocalidad,label:l.nombre}))} styles={{
                            control: (pr) => ({
                                ...pr,
                                height: 45,
                                fontSize: '14px',
                                borderRadius: formErrors.fk_idlocalidad ? 2 : 0,
                                backgroundColor: '#FFFFFF80',
                                borderColor: formErrors.fk_idlocalidad ? '#E40F1B' : pr.borderColor,
                                background: formErrors.fk_idlocalidad ? '#f8f0f0' : 'white'
                            })
                    }} placeholder="Localidad" />
                    </div>
                    <div>
                    <label>Código postal *</label>
                    <input type="text" name="codpost" value={datosDomicilio.codpost || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.codpost?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Código postal *" />
                    </div>
                    {retiro !== 'Retiro al local' && <div>
                    <label>Entre calles *</label>
                  <input type="text" name="entre_calles" value={datosDomicilio.entre_calles || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.entre_calles?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Entre calles" />
                </div>}
                <div>
                  <label>Tipo de documento</label>
                  <Select defaultValue={datosDomicilio.fk_idtipodoc_persona || 7} name="fk_idtipodoc_persona" value={getTipoDocumentoOption(datosDomicilio.fk_idtipodoc_persona)} onChange={opt=>handleSelectChange(opt,'fk_idtipodoc_persona')} options={tipoDocumentoOptions} styles={{
                      control:(pr)=>({ ...pr,height:45,fontSize:'14px',borderRadius:0,backgroundColor:'#FFFFFF80',borderColor:formErrors.fk_idtipodoc_persona?'#ef4444':pr.borderColor})
                  }} placeholder="Tipo de documento" />
                </div>
                <div>
                  <label>Número de documento *</label>
                  <input type="text" name="documento_personal" value={datosDomicilio.documento_personal || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.documento_personal?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Número de documento *" />
                </div>
                <div className={retiro == 'Envía a domicilio' ? 'lg:col-span-2' : ''}>
                  <label>Número de teléfono celular *</label>
                  <input type="text" name="numero_celular" value={datosDomicilio.numero_celular || ''} onChange={handleChange} className={`w-full h-[45px] text-[14px] pl-4 py-4 border-[0.5px] ${formErrors.numero_celular?'border-[#E40F1B] bg-[#f8f0f0] font-bold':'border-[#808184]'} bg-[#FFFFFF80]`} placeholder="Teléfono (código de área) *" />
                </div>
                {retiro == 'Envía a domicilio' && <div className='mt-3 lg:col-span-2'>
                    <label className='text-sm'>Nota para la entrega:*</label>
                    <input type="text" className={`${formErrors.nota ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-black'} border border-opacity-60 w-full rounded-sm h-40 pb-32 pl-2 py-1`} name='nota' value={datosDomicilio?.nota} onChange={handleChange} placesholder='Notas para la entrega *' />
                    {formErrors.nota && <p className='text-xs font-semibold text-[#E40F1B] mb-2'>Campo obligatorio</p>}
                </div>}
              </div>
            )}
          </div>
          <div className="mt-5 flex items-center">
            <input type="checkbox" checked={facturaA} onChange={()=>setFacturaA(f=>!f)} className="h-4 w-4 text-red-600 border-gray-300 rounded focus:ring-red-500" />
            <label className="ml-2 text-[14px] text-[#57585A]">¿Desea factura A?</label>
          </div>
          {facturaA && (
            <>
            {retiro !== 'Retiro al local' && (
                <div className="flex flex-row gap-[10px] mt-[22px]">
                <input
                    checked={!datosDomicilio.tipoDireccion}
                    type="checkbox"
                    id="tipoDireccion"
                    onChange={() => setDatosDomicilio(p => ({
                    ...p,
                    tipoDireccion: !p.tipoDireccion
                    }))}
                />
                <label htmlFor="tipoDireccion" className="text-[14px] text-[#57585A] font-roboto leading-[16px]">
                    Utilizar la dirección de envío como dirección de facturación.
                </label>
                </div>
            )}
            <p className='font-semibold text-lg mt-5'>{retiro !== 'Retiro al local' ? 'Datos de facturación' : 'Datos de factura A'}</p>
            <div className="grid grid-cols-2 gap-5 mt-[15px]">
                <div>
                <label htmlFor="situacion">
                    Situación fiscal *
                </label>
                <select
                    id="situacion"
                    name="situacion"
                    defaultValue={datosDomicilio.situacion || 1}
                    value={datosDomicilio.situacion}
                    onChange={e => setDatosDomicilio(p => ({ ...p, situacion: e.target.value }))}
                    className={`w-full h-[45px] pl-2 border-[0.5px] ${formErrors.situacion ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-[#808184]'} border-opacity-60 bg-[#FFFFFF80] text-[#57585A]`}
                >
                    <option value="1">IVA Responsable Inscripto</option>
                    <option value="2">Responsable Monotributo</option>
                    <option value="4">IVA Sujeto Exento</option>
                </select>
                </div>
                <div>
                <label htmlFor="razon_social">
                    Nombre - Razón social *
                </label>
                <input
                    type="text"
                    id="razon_social"
                    name="razon_social"
                    value={
                        datosDomicilio.razon_social !== undefined && datosDomicilio.razon_social !== null
                            ? datosDomicilio.razon_social
                            : `${datosDomicilio.nombre ?? ''} ${datosDomicilio.apellido ?? ''}`.trim()
                        }
                    onChange={e => setDatosDomicilio(p => ({ ...p, razon_social: e.target.value }))}
                    className={`w-full h-[45px] pl-4 border-[0.5px] ${formErrors.razon_social ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-[#808184]'} border-opacity-60 bg-[#FFFFFF80] text-[#57585A]`}
                    placeholder="Nombre - Razón social *"
                />
                </div>
                <div className="col-span-2">
                <label htmlFor="cuit">
                    CUIT *
                </label>
                <input
                    type="text"
                    id="cuit"
                    name="cuit"
                    value={datosDomicilio.cuit || ''}
                    onChange={e => setDatosDomicilio(p => ({ ...p, cuit: e.target.value.replace(/\D/g, '').slice(0, 11) }))}
                    className={`w-full h-[45px] pl-4 border-[0.5px] ${formErrors.cuit ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-[#808184]'} border-opacity-60 bg-[#FFFFFF80] text-[#57585A]`}
                    placeholder="CUIT *"
                />
                </div>

                {datosDomicilio.tipoDireccion && (
                <>
                    <div>
                        <label htmlFor="calle_facturacion">
                            Calle *
                        </label>
                        <input
                            type="text"
                            id="calle_facturacion"
                            name="calle_facturacion"
                            value={datosDomicilio.calle_facturacion || ''}
                            onChange={e => setDatosDomicilio(p => ({ ...p, calle_facturacion: e.target.value }))}
                            className={`w-full h-[45px] pl-4 border-[0.5px] ${formErrors.calle_facturacion ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-[#808184]'} border-opacity-60 bg-[#FFFFFF80] text-[#57585A]`}
                            placeholder="Calle *"
                        />
                    </div>
                    <div>
                        <label htmlFor="nro_facturacion">
                            Número *
                        </label>
                        <input
                            type="text"
                            id="nro_facturacion"
                            name="nro_facturacion"
                            value={datosDomicilio.nro_facturacion || ''}
                            onChange={e => setDatosDomicilio(p => ({ ...p, nro_facturacion: e.target.value }))}
                            className={`w-full h-[45px] pl-4 border-[0.5px] ${formErrors.nro_facturacion ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-[#808184]'} border-opacity-60 bg-[#FFFFFF80] text-[#57585A]`}
                            placeholder="Número *"
                        />
                    </div>
                    <div>
                    <label htmlFor="piso_facturacion">
                        Piso *
                    </label>
                    <input
                        type="text"
                        id="piso_facturacion"
                        name="piso_facturacion"
                        value={datosDomicilio.piso_facturacion || ''}
                        onChange={e => setDatosDomicilio(p => ({ ...p, piso_facturacion: e.target.value }))}
                        className={`w-full h-[45px] pl-4 border-[0.5px] ${formErrors.piso_facturacion ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-[#808184]'} border-opacity-60 bg-[#FFFFFF80] text-[#57585A]`}
                        placeholder="Piso *"
                    />
                    </div>
                    <div>
                    <label htmlFor="dpto_facturacion">
                        Departamento *
                    </label>
                    <input
                        type="text"
                        id="dpto_facturacion"
                        name="dpto_facturacion"
                        value={datosDomicilio.dpto_facturacion || ''}
                        onChange={e => setDatosDomicilio(p => ({ ...p, dpto_facturacion: e.target.value }))}
                        className={`w-full h-[45px] pl-4 border-[0.5px] ${formErrors.dpto_facturacion ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-[#808184]'} border-opacity-60 bg-[#FFFFFF80] text-[#57585A]`}
                        placeholder="Departamento *"
                    />
                    </div>
                    <div>
                    <label htmlFor="fk_idprov_facturacion">
                        Provincia *
                    </label>
                    <Select
                        name="fk_idprov_facturacion"
                        value={getProvinciaOptionFact(datosDomicilio.fk_idprov_facturacion)} onChange={handleChangeSelectProvFact} options={provinciasFact.map(p => p.descprov==='Capital Federal'?{value:p.idprov,label:'CABA'}:{value:p.idprov,label:p.descprov})} styles={{
                            control:(pr)=>({ ...pr,height:45,fontSize:'14px',borderRadius:0,backgroundColor:'#FFFFFF80',borderColor:formErrors.fk_idprov?'#ef4444':pr.borderColor})
                          }} placeholder="Provincia *"
                    />
                    </div>
                    <div>
                    <label htmlFor="fk_idlocalidad_facturacion">
                        Localidad *
                    </label>
                    <Select
                        name="fk_idlocalidad_facturacion"
                        value={getLocalidadOptionFact(datosDomicilio.fk_idlocalidad_facturacion)} onChange={handleChangeSelectLocalidadFact} options={localidadesFact.map(l=>({value:l.idlocalidad,label:l.nombre}))} styles={{
                            control:(pr)=>({ ...pr,height:45,fontSize:'14px',borderRadius:0,backgroundColor:'#FFFFFF80',borderColor:formErrors.fk_idlocalidad?'#ef4444':pr.borderColor})
                          }} placeholder="Localidad *"
                    />
                    </div>
                    <div>
                    <label htmlFor="codpost_facturacion">
                        Código postal *
                    </label>
                    <input
                        type="text"
                        id="codpost_facturacion"
                        name="codpost_facturacion"
                        value={datosDomicilio.codpost_facturacion || ''}
                        onChange={e => setDatosDomicilio(p => ({ ...p, codpost_facturacion: e.target.value }))}
                        className={`w-full h-[45px] pl-4 border-[0.5px] ${formErrors.codpost_facturacion ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-[#808184]'} border-opacity-60 bg-[#FFFFFF80] text-[#57585A]`}
                        placeholder="Código postal *"
                    />
                    </div>
                </>
                )}
            </div>
            </>
            )}
            {medioPago === '1' && (
                <div>
                    <h3 className="flex flex-row text-lg mt-5">1. Realizar la transferencia bancaria a la siguiente cuenta:</h3>
                    <div className="bg-[#f9f9fb] flex flex-col justify-center items-center h-[30%] pt-10">
                        <p className="lg:px-20 px-5 text-sm opacity-75">
                        Los siguientes son los datos para transferencia bancaria. Cuando realices la transferencia ingresá tu DNI como referencia de la misma. Una vez realizado envianos el comprobante a hola@sentate-conestilo.com
                        </p>
                        <div className="bg-white border text-[13px] border-[#F17470] mb-10 lg:w-1/2 lg:px-0 w-5/6 mt-3">
                        <p className="mb-2">Nuestros detalles bancarios </p>
                        <p className="text-center">TITULAR: ESTILO 1 + 1 SAS <br />CUIT: 30716170299 <br />CUENTA CORRIENTE: 9215-9 064-1 <br />CBU: 00700641-20000009215913 <br />ALIAS: ESTILO.1.1-SAS <br />BANCO: GALICIA</p>
                        </div>
                    </div>
                    <div>
                        <h3 className="flex flex-row text-lg mt-5">2. Realiza los siguientes datos de transferencia:</h3>
                        <div className="grid grid-cols-2 gap-4 mt-5 text-left text-sm">
                        <div className="w-full">
                            <p className="">Fecha de transferencia *:</p>
                            <input
                                required
                                type="date"
                                name="fecha"
                                defaultValue={new Date().toISOString().split('T')[0]}
                                onChange={handleChangeInput}
                                className={`w-full ${errorMensaje == 'La fecha es requerida'  ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : ''} pl-2 h-[40px] border`}
                                />
                        </div>
                        <div className="w-full mb-4">
                            <label htmlFor="banco" className="block text-gray-700">Banco *</label>
                            <Select
                            name="banco"
                            value={selectedBank}
                            onChange={handleChangeSelect}
                            options={options}
                            classNamePrefix="react-select"
                            className={`mt-1 ${errorMensaje == 'El banco es requerido y debe ser un número válido' ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : 'border-gray-300'}`}
                            styles={{
                                control: (provided, state) => ({
                                ...provided,
                                borderColor: errorMensaje == 'El banco es requerido y debe ser un número válido' ? '#E40F1B' : provided.borderColor,
                                '&:hover': {
                                    borderColor: errorMensaje == 'El banco es requerido y debe ser un número válido' ? '#E40F1B' : provided.borderColor,
                                },
                                boxShadow: state.isFocused
                                    ? errorMensaje == 'El banco es requerido y debe ser un número válido'
                                    ? '0 0 0 1px #E40F1B'
                                    : '0 0 0 1px #2684FF'
                                    : provided.boxShadow,
                                }),
                            }}
                            />
                            {formErrors.banco && (
                            <span className="text-red-500 text-sm mt-1">
                                {formErrors.banco}
                            </span>
                            )}
                        </div>
                        <div className="w-full">
                            <p>Importe transferido *</p>
                            <input required type="number" value={comprobante.importe} name="importe" onChange={handleChangeInput} className={`w-full pl-2 h-[40px] border ${errorMensaje == 'El importe es requerido y debe ser un número válido' ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : ''}`} />
                        </div>
                        <div className="w-full">
                            <p>Adjuntar comprobante *</p>
                            <input required type="file" accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
                            name="txtArchivoDocumento" onChange={handleChangeInput} 
                            className={`w-full pl-2 h-[40px] border ${errorMensaje == 'El archivo es requerido' ? 'border-[#E40F1B] bg-[#f8f0f0] font-bold' : ''}`} />
                        </div>
                        {errorComprobante &&(
                      <p className="text-red-500 text-sm mt-1">El comprobante debe ser jpg, jpeg, png, pdf o pesar menos de 10mb</p>)}
                        </div>
                    </div>
                </div>
            )}
            {medioPago === '25' && (
                <div className="">
                    <p className="flex flex-row text-lg mt-5">1. Abrí tu app de preferencia para pagar con <p className="ml-1 font-semibold text-[#E40F1B]">Modo</p></p>
                    <p className="flex flex-row text-lg mt-5">2. Escanea el <p className="font-semibold mx-1 text-[#E40F1B]">QR</p> e ingresá el importe a pagar</p>
                    <div className="">
                        <img src={modoQr} alt="" className="ml-10 mt-5 w-60" />
                    </div>
                </div>
            )}
            {medioPago === '20' && !pass && (
                <div className="relative flex justify-center lg:flex-row-reverse items-center lg:justify-between flex-col my-16">
                    <button
                        onClick={handleMercadoPago}
                        disabled={isProcessing}
                        className={`relative h-[48px] lg:w-1/2 w-full font-HindMadurai bg-[#E40F1B] overflow-hidden ${isProcessing ? 'cursor-not-allowed' : 'cursor-pointer'}`}
                    >
                        <span
                        className="absolute inset-0 flex items-center justify-center text-white pointer-events-none"
                        style={{ zIndex: 0 }}
                        >
                        {buttonText}
                        </span>
                        {isProcessing && (
                        <div
                            className="absolute left-0 bottom-0 h-full bg-[#D9D9D9] transition-all duration-300 pointer-events-none"
                            style={{ width: `${progress}%`, zIndex: 20 }}
                        ></div>
                        )}
                        <handleMercadoPago
                        className="absolute inset-0 flex items-center justify-center text-white pointer-events-none"
                        style={{ zIndex: 10 }}
                        >
                        {buttonText}
                        </handleMercadoPago>
                    </button>
                    <div className="lg:mt-0 mt-10"><a href="/carrito" className="uppercase mt-6 underline text-[#57585A] text-[20px] lg:text-[12px]">VOLVER</a></div>
                </div>
            )}
            <div className='flex lg:justify-between lg:flex-col flex-col mt-0'>
                {medioPago !== '20' && (
                    <>
                    {medioPago == '25' ? <p className="flex flex-row mt-10 text-lg">3. Haz clic en <strong className="font-semibold ml-1 text-[#E40F1B]"> finalizar compra</strong></p>
                    :
                    <h3 className="flex flex-row text-lg mt-5">3. Haz clic en el botón "Confirmar pago":</h3>}
                    <div className='lg:grid lg:grid-cols-2 flex flex-col-reverse gap-5 mt-5 items-center'>
                        <div className=""><a href="/carrito" className="uppercase mt-6 underline text-[#57585A] lg:text-[12px] text-[20px]">VOLVER</a></div>
                        <button
                            onClick={() => {
                            if (!loadingBuy) {
                                handleMercadoPago();
                            }
                            }}
                            className='bg-[#1c1c1c] text-white cols-span-2 mt-10 w-full px-16 lg:pt-0 mb-4 lg:h-10 h-14 py-1 uppercase hover:bg-[#E40F1B]'
                        >
                            {loadingBuy ? (
                            <div className='flex justify-center items-center'>
                                <svg aria-hidden="true" className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-[#E40F1B]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                </svg>
                            </div>
                            ) : (
                            'Confirmar pago'
                            )}
                        </button>
                    </div>
                    </>    
                )}
            </div>
        </div>
         <div className='w-full bg-[#f9f9fb] lg:block hidden ml-10'>
            <div className='sticky p-5 top-10'>
                <p className='uppercase text-left text-lg font-semibold mt-2 '>resumen de compra</p>
                <div>
                {carrito && carrito.length > 0 ? carrito.map((item) => (
                    <div key={item.idproducto}>
                    {Number(item.precio_dolar) !== 0 &&
                        <div>
                            <CardDatos setCarrito={setCarrito} onRemoveInvitado={onRemoveInvitado} precio={medioPago} dolar={precioDolar} item={item} setLoading={setLoading} />
                            <div className='border-b-2 my-2 border-opacity-30'></div>
                        </div>
                    }
                    </div>
                ))
                    :
                    <div className="flex justify-center items-center mt-32 mb-60">
                    <svg aria-hidden="true" className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-[#E40F1B]" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                    </svg>
                    <span className="sr-only">Loading...</span>
                    </div>
                }
                </div>
                <div className='flex flex-col'>
                </div>
                <div>
                {precioTotal !== 0 &&
                    <div>
                    <div className='my-2'></div>
                    <div className='flex justify-between font-semibold'>
                        <p className='text-left'>Subtotal</p>
                        <p className='text-right'>{Number(precioTotal).toLocaleString('es-AR', {
                        style: 'currency',
                        currency: 'ARS',
                        maximumFractionDigits: 0,
                        })}</p>
                    </div>
                    </div>
                }
                {retiro == 'Envía a domicilio' && <div>
                    <div className='border-b-2 my-2'></div>
                    <div className='flex justify-between my-2'>
                    <p>Envío</p>
                    {Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ?
                        <p>GRATIS</p>
                        :
                        envio !== 0 ?
                        <p>+{Number(envio).toLocaleString('es-AR', {
                            style: 'currency',
                            currency: 'ARS',
                            maximumFractionDigits: 0,
                            })}</p>:
                        <p>A cargo del cliente</p>   
                    }
                    </div>
                </div>}
                {(medioPago === '1') && <div className='border-b-2 my-2'></div>}
                {(medioPago === '1') &&
                    <div className='flex justify-between'>
                    <p className='text-left'>Descuento por pago con transferencia:</p>
                    <p className='text-right'>{Number(diferencialConPorcentaje).toLocaleString('es-AR', {
                        style: 'currency',
                        currency: 'ARS',
                        maximumFractionDigits: 0,
                    })}</p>
                    </div>}
                {cuponTrue &&
                    <div>
                    <div className='my-2 border-b-2'></div>
                    <div className='flex justify-between'>
                        <p className='text-left'>Cupon: 15% OFF</p>
                        <p className='text-right'>-{Number(precioCuponRestante).toLocaleString('es-AR', {
                        style: 'currency',
                        currency: 'ARS',
                        maximumFractionDigits: 0,
                        })}</p>
                    </div>
                    </div>
                }
                <div className='border-b-2 my-2'></div>
                <div className='flex justify-between'>
                    <p className='text-left'>TOTAL</p>
                    <p className='text-right'>{Number(((medioPago == '1') && medioPago ? cuponTrue ? precioTotalDescuento - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotalDescuento + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : cuponTrue ? precioTotal - precioCuponRestante + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio) : precioTotal + (Number(precioTotalDescuento) > 200000 && datosDomicilio?.fk_idprov == "2" ? 0 : envio))).toLocaleString('es-AR', {
                    style: 'currency',
                    currency: 'ARS',
                    maximumFractionDigits: 0,
                    })}</p>
                </div>
                <div className='border-b-2 my-2'></div>
                <div className='flex justify-between'>
                    <p onClick={() => {
                                    setIsOpen(false);
                                    setCarritoOpen(true);
                                }} className='text-left text-[#E40F1B] hover:cursor-pointer underline text-sm opacity-70'>Modificar carrito</p>
                    <p className='text-right text-sm opacity-70'>Precio en pesos argentinos. Incluye impuestos.</p>
                </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  )
}

export default UnifiedCheckout